// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__Ha+Ky","closeBtn":"Modal_closeBtn__mlOa4","title":"Modal_title__3HkNf"};